import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DataService } from '../../../core/data/data-service';
import { PromoContentService } from '../../../core/routing/services/asset-library/promo-content.service';
import { CommonService } from './../../../common/services/common.service';
import { PromoContentConfiguration } from '../../../modules/asset-library/promo-content/interfaces/promo-content.i';
import { ProfileUpdateResponse } from '../../create-profile/interface/profile.i';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { OemService } from '../../../core/routing/services/oem/oem.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { OemConstants } from '../../../core/routing/services/oem/constants/oem.constants';
import { Content } from '../interface/oem-portal-interface.i';
import { first } from 'rxjs/internal/operators/first';
import { CreatePartnerContentContentResponse, LayoutContent, PartnerContentConfiguration, PartnerContentGroupPage } from '../new-partner-content/interfaces/new-partner-content.i';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { PartnerContentPageComponent } from '../partner-content-page/partner-content-page.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'iposcen-create-partner-content',
  templateUrl: './create-partner-content.component.html',
  styleUrls: ['./create-partner-content.component.scss']
})
export class CreatePartnerContentComponent implements OnInit {
  @ViewChild('deleteModal') deleteModal: ElementRef;
  @ViewChild('searchValue') animateThis: ElementRef;
  @ViewChild('page1') page1: PartnerContentPageComponent;
  @ViewChild('page2') page2: PartnerContentPageComponent;
  @ViewChild('page3') page3: PartnerContentPageComponent;
  @Output() readonly viewOn = new EventEmitter();
  @Output() readonly showAuthorTabs = new EventEmitter();
  @Output() readonly contentID = new EventEmitter();
  @Output() readonly autoID = new EventEmitter();
  pageData;
  whichPageDelete;
  @Output() readonly isNewPartnerContent = new EventEmitter();
  tabIndex = 0;
  displayPromoContentGroups = [];
  allContentData = [];
  displayContents = [];
  page: number;
  tableSize: number;
  showFrom: number;
  showTo: number;
  maxSize = 5;
  lCGlayout = 4;
  contentGrpData: any;
  pageType = GlobalConstants.PARTNER_CONTENT_GROUP;
  pages: any; // update the no of pages for edit.
  mediaObjects: any[] = [];
  editCheck: boolean;
  clickable = false; // This is to enable tabs click only after clicking on Save & Proceed.TODO: will remove this later.
  showPromoContentName: string; // To Show logocontentname as tab title.
  buttonName: string;
  isNavigated = false;
  selctedContGrpsForProfile: any = {
    contentGrps: [],
    showOnDevice: []
  };
  isPage3Created: boolean;
  profileDataResponse: ProfileUpdateResponse;
  partnerPageComponent: PartnerContentPageComponent;
  showTabs: boolean;
  isViewOpen: boolean;
  globalSortBy: string;
  globalSortValue: string;
  paginationCount: number;
  totalPages: number;
  isMasterSel: boolean;
  allSystemIdData: any;
  allreviewStatusData: any;
  userId = sessionStorage.getItem('userId');
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + OemConstants.SKU_COMMON + AssetLibraryConstants.SLASH;
  editTooltip = OemConstants.EDIT_TEXT;
  deleteTooltip = OemConstants.DELETE_TEXT;
  private ngUnsubscribe = new Subject();
  searchClose: boolean;
  isDisabled = true;
  filterString: string;
  selectFilterQueue = {};
  searchQueue = {};
  sortQueue = {};
  searchData: string;
  closeFilter: boolean;
  systemIdDropdownSelectedValue: string;
  reviewStatusDropdownSelectedValue: string;
  showHideFilters = true;
  searchTag: string = 'contentnamesearch';
  hasData: boolean;
  editPartnerContentData: any;
  isSubmit: boolean = false;
  hasSearchData: boolean;
  disableSave: any;
  onlyNotHasData: boolean;
  searchByContentName: string = OemConstants.CONTENTNAME_PLACEHOLDER;
  pagesContent: any;
  isEdit: any;
  editContentId: any;
  editAutoId: any;
  storeImageData = new Map();
  partnerContentToDelete: string;
  partnerContentToDeleteName: string;
  autoIdOfPartnerCG: string
  pagelen: number;
  approved_tooltip_text = OemConstants.APPROVED_TOOLTIP_DESC;
  submitted_tooltip_text = OemConstants.SUBMITTED_TOOLTIP_DESC;
  returned_tooltip_text = OemConstants.RETURNED_TOOLTIP_DESC;
  saved_tooltip_text = OemConstants.SAVED_TOOLTIP_DESC;
  duplicate = OemConstants.DUPLICATE_EDIT;
  lang: string[];
  sytsemIdSelectedLanguage: string[] = [];
  isAllLanguagesSelected = false;
  duplicacy = false;
  contentName: any;
  contentNameDisplay: string;
  colSortKey: string = "";

  constructor(
    private cmnService: CommonService,
    private promoContentService: PromoContentService,
    private dataService: DataService,
    private oemService: OemService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.contentNameDisplay = OemConstants.CONTENT_GROUP_DETAILS;
    if (this.tabIndex === 0) {
      this.isNewPartnerContent.emit(false)
    }
    this.clickable = false;
    this.page = 1;
    this.tableSize = 10;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize);
    this.isMasterSel = false;
    this.pages = {};
    this.isViewOpen = false;
    this.globalSortBy = OemConstants.CONTENT_LAST_UPDATED;
    this.globalSortValue = OemConstants.DESCENDING_ORDER;
    this.searchClose = false;
    this.closeFilter = false;
    this.hasData = true;
    this.hasSearchData = true;
    this.onlyNotHasData = true;
    this.getFilterSearchData();
    this.cmnService.pageDataTologoObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        // Once page is updated.
        const partnerContent = this.contentGrpData?.content;
        let configurations = partnerContent?.configurations;
        if (res.data.layoutContent[3].imageUrl !== '') {
          this.prepareMediaSet(res, partnerContent?.id);
        }
        const checkJson = this.checkExistance(configurations?.contentGroupPages, 'pageNum', res.number);
        if (checkJson.hasMatch) {// If there is configuration object already for the page number
          // Update the pages
          configurations.contentGroupPages[checkJson.matchedIndex] = {
            pageNum: res.number,
            backgroundColor: res.data.bgcolor,
            fontColor: res.data.hcolor,
            uiLayout: this.getUILayoutNameByID(res.data.layout),
            assetID: res.data.logoMedia.logoAssetId,
            assetName: res.data.logoMedia.name,
            assetType: res.data.logoMedia.format,
            content: this.setLayoutContent(res.data),
            hotspots: this.setHotspotContent(res.data)
          };
        } else {
          // New page structure for OEM packaging
          const contentPage: PartnerContentGroupPage = {
            pageNum: res.number,
            backgroundColor: res.data.bgcolor,
            fontColor: res.data.hcolor,
            uiLayout: this.getUILayoutNameByID(res.data.layout),
            assetID: res.data.logoMedia.logoAssetId,
            assetName: res.data.logoMedia.name,
            assetType: res.data.logoMedia.format,
            content: this.setLayoutContent(res.data),
            hotspots: this.setHotspotContent(res.data)
          };
          configurations.contentGroupPages.push(contentPage);
        }
        this.contentGrpData.content = partnerContent;
      });
  }
  editDoneConfig(event) {
    this.editPartnerContentData = event;
  }
  //New page structure for OEM packaging
  setLayoutContent(data) {
    let content: any[] = [];
    for (let layout of data.layoutContent) {
      if (layout.position === 'leftTop') {
        let imageAData: LayoutContent = {
          assetID: layout.imageAId,
          assetName: layout.imageAName,
          assetType: layout.imageAFileType,
          title: layout.heading,
          subTitle: layout.bodyA,
          fontSize: this.fontSizePixel(layout.bodyASize),
          alignment: layout.position
        }
        content.push(imageAData);
      } else if (layout.position === 'leftBottom') {
        let imageBData: LayoutContent = {
          assetID: layout.imageBId,
          assetName: layout.imageBName,
          assetType: layout.imageBFileType,
          title: layout.heading,
          subTitle: layout.bodyB,
          fontSize: this.fontSizePixel(layout.bodyBSize),
          alignment: layout.position
        }
        content.push(imageBData);
      } else if (layout.position === 'right') {
        let heroImageData: LayoutContent = {
          assetID: layout.heroImageId,
          assetName: layout.heroImageName,
          assetType: layout.heroImageFileType,
          title: layout.heading,
          subTitle: layout.body,
          fontSize: '',
          alignment: layout.position
        }
        content.push(heroImageData);
      } else if (layout.position === 'i-center') {
        let singleImageData: LayoutContent = {
          assetID: layout.singleImageId,
          assetName: layout.imageName,
          assetType: layout.imageFileType,
          title: data.heroImageContent.heading,
          subTitle: layout.body,
          fontSize: this.fontSizePixel(layout.size),
          alignment: layout.position
        }
        content.push(singleImageData);
      } else {
        let videoData: LayoutContent = {
          assetID: layout.videoId,
          assetName: layout.videoName,
          assetType: layout.videoFileType,
          title: data.heroImageContent.heading,
          subTitle: '',
          fontSize: '',
          alignment: layout.position
        }
        content.push(videoData);
      }
    }
    return content;
  }

  setHotspotContent(data: any): any[] {
    return data?.hotspots;
  }

  getPages(data) {
    this.pageData = data;
  }
  // To hold all pages media objects and its metada.
  prepareMediaSet(res: any, id: string) {
    const checkJson = this.checkExistance(this.mediaObjects, 'pageNum', res.number);
    if (checkJson.hasMatch) {
      // Update the pages
      this.mediaObjects[checkJson.matchedIndex] = {
        id: id,
        media: res.data.layoutContent[3],
        pageNum: res.number
      };
      if (typeof res.data.layoutContent[3] === 'object' && res.data.layoutContent[3]) {
        this.mediaObjects[checkJson.matchedIndex].uploaded = true;
      }
    } else {
      const dataObj: any = {
        id: id,
        media: res.data.media,
        pageNum: res.number
      };
      if (typeof res.data.layoutContent[3] === 'object' && res.data.layoutContent[3]) {
        dataObj.uploaded = true;
      }
      this.mediaObjects.push(dataObj);
    }

  }

  checkExistance(data, key, compValue) {
    const checkJSON = {
      hasMatch: false,
      matchedIndex: -1
    };
    for (let index = 0; index < data.length; index += 1) {
      if (data[index][key] === compValue) {
        checkJSON.hasMatch = true;
        checkJSON.matchedIndex = index;
        break;
      }
    }

    return checkJSON;
  }

  fontSizePixel(size) {
    if (size === GlobalConstants.SMALL) { return GlobalConstants.FONTSIZE_12PX; }
    if (size === GlobalConstants.MEDIUM) { return GlobalConstants.FONTSIZE_14PX; }
    if (size === GlobalConstants.LARGE) { return GlobalConstants.FONTSIZE_16PX; }
  }

  getUILayoutNameByID(id) {// TODO - Confirm with Sujay if layout name is correct
    if (id === 1) {
      return '3-asset-layout';
    } else if (id === 2) {
      return '1-image-layout';
    } else if (id === 3) {
      return '1-video-layout';
    } else if (id === 4) {
      return '1-hotspot-layout';
  }
}

  getAllContents(filterString?: string) {
    this.oemService.getAllContents(this.globalSortBy, this.globalSortValue, filterString)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllContentResponse => {
        this.allContentData = getAllContentResponse.contents as Content[];
        this.paginationCount = (getAllContentResponse.paginationContext.totalItems);
        this.totalPages = (getAllContentResponse.paginationContext.totalPages);
        this.displayContents = [];
        this.allContentData.forEach(ele => {
          ele.isSelected = this.isMasterSel;
          this.displayContents.push(ele);
        });
        if (filterString) {
          if (this.displayContents.length === 0) {
            this.hasSearchData = false;
            this.hasData = false;
            this.onlyNotHasData = false;
            this.showFrom = 0;
            this.showTo = 0;
          } else {
            this.hasSearchData = true;
            this.hasData = true;
            this.displayContents = [];
            this.allContentData.forEach(ele => {
              ele.isSelected = this.isMasterSel;
              this.displayContents.push(ele);

            });
            this.allSystemIdData = getAllContentResponse.systemID.sort();
            this.allreviewStatusData = getAllContentResponse.reviewStatus.sort();
          }

        } else {
          if (this.displayContents.length === 0) {
            this.hasData = false;
            this.hasSearchData = false;
            this.onlyNotHasData = true;
            this.showFrom = 0;
            this.showTo = 0;
          } else {
            this.showFrom = ((this.page - 1) * this.tableSize) + 1;
            this.hasData = true;
            this.onlyNotHasData = false;
            this.displayContents = [];
            this.allContentData.forEach(ele => {
              ele.isSelected = this.isMasterSel;
              this.displayContents.push(ele);

            });
            this.allSystemIdData = getAllContentResponse.systemID.sort();
            this.allreviewStatusData = getAllContentResponse.reviewStatus.sort();
          }
        }

        if (this.displayContents.length < 10) {
          this.showTo = this.displayContents.length;
        } else {
          this.showTo = this.page * this.tableSize;
        }
        //Fix for IIT2-10086
        if (this.colSortKey === 'contentName') {
          let sortOrderAsc = this.globalSortValue;
          this.displayContents.sort(function (a, b) {
            if (sortOrderAsc === OemConstants.ASCENDING_ORDER) {
              return a.contentName.localeCompare(b.contentName, undefined, { numeric: true, sensitivity: 'base' });
            } else {
              return b.contentName.localeCompare(a.contentName, undefined, { numeric: true, sensitivity: 'base' });
            }
          })
        }
      });
  }


  sort(sortKey: string) {
    this.colSortKey = sortKey;
    switch (sortKey) {
      case ('contentName'):
        this.sortingTableWithAscandDesc('contentName');
        break;
      case ('systemID'):
        this.sortingTableWithAscandDesc('systemID');
        break;
      case ('languageCategory'):
        this.sortingTableWithAscandDesc('languageCategory');
        break;
      case ('reviewStatus'):
        this.sortingTableWithAscandDesc('reviewStatus');
        break;
      case ('updatedTime'):
        this.sortingTableWithAscandDesc('updatedTime');
        break;
      case ('editedByName'):
        this.sortingTableWithAscandDesc('editedByName');
        break;
      default: {
      }
    }
  }

  sortingTableWithAscandDesc(tempval: string) {
    this.globalSortValue = this.globalSortValue !== OemConstants.ASCENDING_ORDER ? OemConstants.ASCENDING_ORDER :
      OemConstants.DESCENDING_ORDER;
    this.globalSortBy = tempval;
    this.getFilterSearchData();
  }

  searchContentName(searchData) {
    this.searchClose = true;

    if (searchData && this.searchTag) {
      this.searchQueue[this.searchTag] = searchData;
      this.getFilterSearchData();
    } else {
      this.getAllContents();
      this.page = 1;
    }
    this.isMasterSel = false;
    this.isDisabled = true;

  }

  searchContentsonEnter(searchData) {
    this.animateThis.nativeElement.blur();
    this.searchContentName(searchData);
  }

  clearSearch(val: string) {
    if (val?.length === 0 && this.searchClose) {
      this.searchClose = false;
      this.animateThis.nativeElement.value = '';
      this.searchQueue = {};
      this.getFilterSearchData();
      this.hasSearchData = true;
      this.searchData = OemConstants.EMPTY_VALUE;
      this.showFrom = this.page = 1;
      this.showTo = 10;
      this.isDisabled = true;
      this.isMasterSel = false;
    }
  }

  clearSearchDirect() {
    this.searchClose = false;
    this.animateThis.nativeElement.value = '';
    this.searchQueue = {};
    this.getFilterSearchData();
    this.searchData = OemConstants.EMPTY_VALUE;
    this.showFrom = this.page = 1;
    this.showTo = 10;
    this.hasSearchData = true;
    this.isDisabled = true;
    this.isMasterSel = false;
  }

  onFilter(selectedFilterName: string, selectedValue: string) {
    this.closeFilter = true;
    switch (selectedFilterName) {
      case 'systemIDfilter':
        this.systemIdDropdownSelectedValue = selectedValue;;
        break;
      case 'reviewStatusfilter':
        this.reviewStatusDropdownSelectedValue = selectedValue;
        break;
      default:
        return;
    }
    this.selectFilterQueue[selectedFilterName] = selectedValue;
    this.getFilterSearchData();
    this.searchClose = false;
    this.searchData = OemConstants.EMPTY_VALUE;
    this.page = 1;
    this.isDisabled = true;
    this.isMasterSel = false;
  }

  getFilterData() {
    this.filterString = '';
    for (const [filterKeyName, fliterData] of Object.entries(this.selectFilterQueue)) {
      if (this.filterString === '') {
        this.filterString = '?' + filterKeyName + '=' + fliterData;
      } else {
        this.filterString += '&' + filterKeyName + '=' + fliterData;
      }
    }
    this.oemService.getContentsByFilter(this.filterString)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getFilterContentResponse => {
        this.displayContents = getFilterContentResponse.contents as Content[];
        this.displayContents = [...new Set(this.displayContents)];
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
        if (this.displayContents.length === 0) {
          this.showFrom = 0;
          this.showTo = 0;
        } else {
          this.allSystemIdData = [...new Set(getFilterContentResponse.contents.map(ele => ele.systemID))].sort();
          this.allreviewStatusData = [...new Set(getFilterContentResponse.contents.map(ele => ele.reviewStatus))].sort();
        }
      });
  }

  clearFilter(filterName?: string) {
    this.page = 1;
    this.isDisabled = true;
    this.isMasterSel = false;
    if (filterName && filterName === 'systemIDfilter') {
      delete this.selectFilterQueue[filterName];
      this.allSystemIdData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.filterString = '';
        this.closeFilter = false;
      }
      this.systemIdDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === 'reviewStatusfilter') {
      delete this.selectFilterQueue[filterName];
      this.allreviewStatusData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.filterString = '';
        this.closeFilter = false;
      }
      this.reviewStatusDropdownSelectedValue = '';
      this.getFilterSearchData();

    } else {
      this.filterString = '';
      this.selectFilterQueue = {};
      this.getFilterSearchData();
      this.closeFilter = false;
      this.searchClose = false;
      this.searchData = OemConstants.EMPTY_VALUE;
      this.allSystemIdData = [];
      this.allreviewStatusData = [];
      this.systemIdDropdownSelectedValue = '';
      this.reviewStatusDropdownSelectedValue = '';

    }
  }

  getFilterSearchData() {
    this.filterString = '';
    this.page = 1;
    if (this.selectFilterQueue || this.searchQueue || this.sortQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.selectFilterQueue)) {
        this.filterString += `&${filterKeyName}=${fliterData}`;
      }
      if (this.searchQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      if (this.sortQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.sortQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      this.getAllContents(this.filterString);
    } else {
      this.getAllContents();
    }
  }

  onTableDataChange(event) {
    this.page = event;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
  }

  checkSpell(data) {
    if (data === 'saved') {
      return OemConstants.SAVED;
    } else if (data === 'approved') {
      return OemConstants.APPROVED;
    } else if (data === 'submitted') {
      return OemConstants.SUBMITTED;
    } else {
      return OemConstants.RETURNED;
    }
  }
  cancel() {
    this.dataService.setPromoContent(undefined);
    if (this.contentGrpData) {
      for (let each of this.displayPromoContentGroups) {
        if (each.id === this.contentGrpData.promotionalContent.id) {
          if (typeof each.configurations === 'string') {
            each.configurations = JSON.parse(each.configurations);
          }
          break;
        }
      }
    }
    this.setIndex(0);
    this.mediaObjects = [];
    this.pages = {};
    this.clickable = false;
    this.editCheck = false;
  }

  setCreatedGrpID(data) {
    this.buttonName = this.promoContentService.buttonName;

    if (typeof data === 'object' && data.cancel) {
      this.setIndex(0);
      this.pages = {};
      this.editCheck = false;
    } else {
      this.selctedContGrpsForProfile = {
        contentGrps: [],
        showOnDevice: []
      };
      this.page = 1; // set pagination to 1
      this.pages.page1 = true;
      this.isPage3Created = this.checkPages();
      this.contentGrpData = data;
      if (typeof this.contentGrpData.content.configurations === 'string') {
        this.contentGrpData.content.configurations =
          JSON.parse(this.contentGrpData.content.configurations) as PartnerContentConfiguration;
      }
      // this.showPromoContentName = this.contentGrpData.promotionalContent.configurations.publishedName;
      this.clickable = true;
      this.setIndex(2);
    }
    // this.mediaObjects = [];
  }
  /*when user opens pages*/
  setPreviewLayout(data) {
    this.lCGlayout = data;
  }
  /*when users slects layout*/
  setIndex(value: number) {
    this.tabIndex = value;
    if (this.tabIndex === 1) {
      this.isNewPartnerContent.emit(true)
    }
    if (Object.keys(this.selectFilterQueue).length > 0) {
      this.clearFilter();
    }
  }

  createPartnerContent() {
    this.clickable = false;
    this.editPartnerContentData = undefined;
    this.showAuthorTabs.emit(false);
    this.mediaObjects = [];
    this.dataService.setPromoContent(undefined);
    this.tabIndex = 1;
    this.isNewPartnerContent.emit(true);
    this.pages = {};
  }

  setLayout(selected) {
    this.lCGlayout = selected;
    this.cmnService.emitLayout(selected);
  }

  refreshPromoContentdata() {
    this.setIndex(0);
    this.mediaObjects = [];
  }

  checkPages() {
    if (this.pages.page1 && this.pages.page2 && this.pages.page3) {
      return true;
    }

    return false;
  }

  redirectToList() {
    this.setIndex(0);
    // this.closeModal(this.applyModal)
  }

  navigate() {
    this.isNavigated = true;
    this.setIndex(1);
    this.clickable = false;
  }

  addPage() {
    const keyLen = Object.keys(this.pages).length;
    if (keyLen === 0) {
      this.pages.page1 = true;
      this.setIndex(2);
    } else if (keyLen === 1) {
      this.pages.page2 = true;
      this.setIndex(3);
    } else {
      this.pages.page3 = true;
      this.setIndex(4);
    }
    this.pagelen = Object.entries(this.pages).length;
    this.isPage3Created = this.checkPages();
  }

  switchLayout() {
    this.contentGrpData.content.configurations.contentGroupPages.forEach(element => {
      if (element.content.length > 1) {
        if (element.uiLayout === '1-image-layout') {
          element.content.splice(element.content.findIndex(item => item.alignment === 'leftTop'), 1);
          element.content.splice(element.content.findIndex(item => item.alignment === 'leftBottom'), 1);
          element.content.splice(element.content.findIndex(item => item.alignment === 'right'), 1);
          element.content.splice(element.content.findIndex(item => item.alignment === 'v-center'), 1);
        } else if (element.uiLayout === '3-asset-layout') {
          if (element.content.length > 3) {
            element.content.splice(element.content.findIndex(item => item.alignment === 'i-center'), 1);
            element.content.splice(element.content.findIndex(item => item.alignment === 'v-center'), 1);
          }
        } else {
          element.content.splice(element.content.findIndex(item => item.alignment === 'leftTop'), 1);
          element.content.splice(element.content.findIndex(item => item.alignment === 'leftBottom'), 1);
          element.content.splice(element.content.findIndex(item => item.alignment === 'right'), 1);
          element.content.splice(element.content.findIndex(item => item.alignment === 'i-center'), 1);
        }
      }
    });
  }

  updatePCG() {
    this.switchLayout();
    const updatePartnerContent: CreatePartnerContentContentResponse = this.contentGrpData as CreatePartnerContentContentResponse;
    // Once page is updated.
    const partnerContent = updatePartnerContent.content;
    if (typeof partnerContent.configurations !== 'string') {
      partnerContent.configurations = JSON.stringify(partnerContent.configurations);
    }
    const partnerContentConfig = partnerContent.configurations;
    this.oemService.patchPartnerContentById(partnerContentConfig, updatePartnerContent.content.autoID,
      updatePartnerContent.content.contentID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (putLogoContentResponse: CreatePartnerContentContentResponse) => {
        // Once the update call is successful, call a PUT call for the logo
        this.showAuthorTabs.emit(true);
        this.isNewPartnerContent.emit(false);
        this.pages = {};
        this.setIndex(0);
        this.clickable = false;
        if (Object.keys(this.selectFilterQueue).length > 0) {
          this.clearFilter();
        } else {
          this.getAllContents();
        }
      },
        error => {
        }
      );
  }

  loadPreview(data) {
    const pageValue = data;
  }
  openView(autoID, contentID) {
    this.viewOn.emit(true);
    this.isViewOpen = true;
    this.contentID.emit(contentID);
    this.autoID.emit(autoID);
  }
  editPartnerContent(data, duplicate?) {
    this.clickable = false;
    this.oemService.getContentDatabyContentID(data.autoID, data.contentID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllContentResponse => {
        if (duplicate) {
          this.sytsemIdSelectedLanguage = [];
          let lang = getAllContentResponse.content.languages;
          this.lang = JSON.parse(lang);
          let data = this.lang.map(lang => {
            this.sytsemIdSelectedLanguage.push(lang);
            if (this.sytsemIdSelectedLanguage.length >= 31) {
              this.isAllLanguagesSelected = true;
            } else {
              this.isAllLanguagesSelected = false;
            }
          })
        }
        if (this.isAllLanguagesSelected) {
          this.tabIndex = 0;
        } else {
          if (duplicate) this.duplicacy = true;
          else this.duplicacy = false;
          getAllContentResponse.content.contentID = data.contentID;
          this.showAuthorTabs.emit(false);
          this.isNewPartnerContent.emit(true);
          this.tabIndex = 1;
          this.isNavigated = true;
          this.setIndex(1);
          this.editPartnerContentData = getAllContentResponse.content;
          this.contentName = getAllContentResponse.content.contentName;
          this.contentNameDisplay = this.duplicacy ? OemConstants.COPY_SPACE + this.contentName + OemConstants.SPACE_DETAILS : OemConstants.CONTENT_GROUP_DETAILS;
          this.isEdit = true;
          this.editContentId = this.editPartnerContentData.contentID;
          this.editAutoId = this.editPartnerContentData.autoID;
          this.pageData = this.editPartnerContentData;
          this.pages = {};
          JSON.parse(this.editPartnerContentData.configurations).contentGroupPages.forEach((e, i) => {
            this.pages["page" + (i + 1)] = true;
          });
          this.pagelen = Object.entries(this.pages).length;
        }
      });
  }
  closePopup() {
    this.isAllLanguagesSelected = false;
  }

  submit(autoID, contentID) {
    this.isSubmit = true;
    const submitAction = {
      action: 'submit',
    }

    this.oemService.submitPartnerContent(JSON.stringify(submitAction), autoID, contentID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(response => {
      })

  }
  onCloseSubmitSuccessPopup() {
    this.isSubmit = false;
    this.getAllContents();
    location.reload();
  }

  showHeaders(show) {
    this.showAuthorTabs.emit(show)
  }

  cancelCreation(show, isNewContentGroup?) {
    this.tabIndex = 0;
    this.showAuthorTabs.emit(show)
    this.isNewPartnerContent.emit(isNewContentGroup)
    setTimeout(() => {
      if (Object.keys(this.selectFilterQueue).length > 0) {
        this.clearFilter();
      } else {
        this.getAllContents();
      }
    }, 0);
  }

  showImageValue(data) {
    this.disableSave = data;
  }
  openPopup(modal, pageNumber) {
    this.modalService.open(modal);
    this.whichPageDelete = pageNumber;
  }
  deletePages(which) {
    this.isPage3Created = false;
    let pagesLen = Object.entries(this.pages).length;
    this.pagelen = Object.entries(this.pages).length;
    if (pagesLen > 1) {
      delete this.pages["page" + (pagesLen)];
      this.pagelen -= 1;
    } else {
      this.page1.update(undefined, 1);
    }
    let configurations;
    let updatedPages = [];
    if (typeof this.contentGrpData.content.configurations === 'string') {
      configurations = JSON.parse(this.contentGrpData.content.configurations) as PartnerContentConfiguration;
    } else {
      configurations = this.contentGrpData.content.configurations as PartnerContentConfiguration;
    }
    configurations.contentGroupPages.splice(which, 1);
    configurations.contentGroupPages.forEach((e, i) => {
      e.pageNum = i + 1;
      updatedPages.push(e);
    });

    configurations.contentGroupPages = updatedPages;
    if (!!this.page1) {
      this.page1.update(configurations);
    } else if (!!this.page2) {
      this.page2.update(configurations);
    } else {
      this.page3.update(configurations);
    }
    configurations.contentGroupPages.forEach((e, i) => {
      if (which === 0) {
        this.setIndex(2)
      } else {
        this.setIndex(which + 1);
      }
    });
  }

  openDeleteModal(contentId: string, autoId: string) {
    this.partnerContentToDelete = this.displayContents.find(ele => ele.contentID === contentId).contentID;
    this.autoIdOfPartnerCG = this.displayContents.find(ele => ele.autoID === autoId).autoID;
    this.partnerContentToDeleteName = this.displayContents.find(ele => ele.contentID === contentId).contentName;
    this.openModal(this.deleteModal);
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  deletePartnerCG(contentId: string, autoId: string) {
    // Delete API Intergration pending

    this.oemService.deletePartnerContent(autoId, contentId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(deleteResponse => {
        if (deleteResponse.responseContext.success) {
          this.closeModal(this.deleteModal);
          setTimeout(_ => { this.getAllContents(this.filterString); }, 2000);
        }
      },
        error => {
          this.closeModal(this.deleteModal);
        })
  }
  callOnEdit(data) {
    this.editPartnerContentData = data[0];
    this.tabIndex = data[1];
    JSON.parse(this.editPartnerContentData.configurations).contentGroupPages.forEach((e, i) => {
      this.pages["page" + (i + 1)] = true;
    });
    this.pagelen = Object.entries(this.pages).length;
  }
  checkLangLenght(data) {
    this.isAllLanguagesSelected = data.length >= 31;
    if (this.isAllLanguagesSelected) {
      this.tabIndex = 0;
      this.showAuthorTabs.emit(true);
    }
  }
}

